// screens/ProfileScreen.js
// PrizeReal — Perfil del usuario
// Muestra datos básicos, nivel actual, botón a Planes y logout.

import React, { useState } from "react";
import { getUserLevel } from "../config/security";
import useTranslation from "../i18n/useTranslation";
import "./ProfileScreen.css";

const IconLogout = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M16 17l5-5-5-5M21 12H9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconPlans = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor" strokeWidth="1.8"/>
    <path d="M8 10h8M8 14h5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const IconChevron = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ProfileScreen = ({ authHook, onNavigate }) => {
  const { t } = useTranslation();
  const { user, profile, logout } = authHook;
  const [loggingOut, setLoggingOut] = useState(false);

  const totalClicks = profile?.totalClicks ?? 0;
  const level = getUserLevel(totalClicks);

  const handleLogout = async () => {
    setLoggingOut(true);
    try {
      await logout();
    } catch (err) {
      console.error("[ProfileScreen] logout error:", err);
      setLoggingOut(false);
    }
  };

  return (
    <div className="profile-screen">
      <header className="profile-screen__header">
        <h1 className="profile-screen__title">Perfil</h1>
      </header>

      <div className="profile-screen__body">

        {/* Avatar + datos del usuario */}
        <div className="profile-screen__card profile-screen__user-card">
          <div className="profile-screen__avatar">
            {user?.photoURL ? (
              <img src={user.photoURL} alt={user.displayName} className="profile-screen__avatar-img" />
            ) : (
              <span className="profile-screen__avatar-initial">
                {user?.displayName?.charAt(0)?.toUpperCase() ?? "?"}
              </span>
            )}
          </div>
          <div className="profile-screen__user-info">
            <p className="profile-screen__user-name">{user?.displayName ?? "Usuario"}</p>
            <p className="profile-screen__user-email">{user?.email}</p>
            <div className="profile-screen__level-badge">
              <span>{level.emoji}</span>
              <span>{level.name}</span>
              <span className="profile-screen__clicks">{totalClicks} clicks</span>
            </div>
          </div>
        </div>

        {/* Acciones */}
        <div className="profile-screen__section">
          <p className="profile-screen__section-title">Cuenta</p>

          <div className="profile-screen__menu">
            <button
              className="profile-screen__menu-item"
              onClick={() => onNavigate("plans")}
            >
              <div className="profile-screen__menu-left">
                <IconPlans />
                <span>Planes para comercios</span>
              </div>
              <IconChevron />
            </button>
          </div>
        </div>

        {/* Logout */}
        <div className="profile-screen__section">
          <button
            className="profile-screen__logout-btn"
            onClick={handleLogout}
            disabled={loggingOut}
          >
            <IconLogout />
            {loggingOut ? "Cerrando sesión…" : "Cerrar sesión"}
          </button>
        </div>

        {/* Versión */}
        <p className="profile-screen__version">PrizeReal · prizereal.com</p>

      </div>
    </div>
  );
};

export default ProfileScreen;
